import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import Button from '../../components/common/Button/Button';
import Modal from '../../components/common/Modal/Modal';
import InputField from '../../components/common/InputField/InputField';
import styles from '../Documents/DocumentsPage.module.scss';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { documentService } from '../../services/documentService';
import { bankDocumentService } from '../../services/bankDocumentService';
import { API_BASE_URL, BACKEND_BASE_URL } from '../../utils/constants';
import adsService, { Ads, CreateAdsData } from '../../services/adsService';
import { formatDateDMY } from '../../utils/helpers';

const AdsPage: React.FC = () => {
  const { auth } = useAuth();
  const [documents, setDocuments] = useState<Ads[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState<Ads | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [documentName, setDocumentName] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDocuments, setFilteredDocuments] = useState<Document[]>([]);

  // Check if user has document management permissions
  // const canManageDocuments = auth.user?.role === 'admin' || 
  //   auth.user?.permissions?.canManageDocuments;

  useEffect(() => {
    // if (canManageDocuments) {
      fetchDocuments();
    // }
  }, []);

  // Filter documents based on search term
  // useEffect(() => {
  //   console.log('Filter effect triggered - documents:', documents, 'searchTerm:', searchTerm);
    
  //   if (!documents) {
  //     console.log('No documents, setting empty filtered array');
  //     setFilteredDocuments([]);
  //     return;
  //   }
    
  //   const filtered = documents.filter(doc => {
  //     // Validate that doc is a proper object with required properties
  //     if (!doc || typeof doc !== 'object') {
  //       console.log('Invalid doc object:', doc);
  //       return false;
  //     }
  //     if (!doc.name || !doc.original_name) {
  //       console.log('Doc missing name or original_name:', doc);
  //       return false;
  //     }
      
  //     return doc.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //            doc.original_name.toLowerCase().includes(searchTerm.toLowerCase());
  //   });
    
  //   console.log('Filtered documents:', filtered);
  //   setFilteredDocuments(filtered);
  // }, [searchTerm, documents]);

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      console.log('Fetching documents...');
      const response = await adsService.getAll();
      console.log('API Response:', response);
      
      // Validate and filter out invalid documents
      const validDocuments = response.filter(doc => {
        const isValid = doc && 
               typeof doc === 'object' && 
               doc.id && 
               doc.image_url;
        
        if (!isValid) {
          console.log('Invalid document found:', doc);
        }
        
        return isValid;
      });
      
      console.log('Valid documents:', validDocuments);
      setDocuments(validDocuments);
    } catch (error) {
      console.error('Error fetching documents:', error);
      toast.error('Failed to load documents');
      setDocuments([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      // Auto-fill document name with file name (without extension)
      const fileName = file.name.replace(/\.[^/.]+$/, '');
      setDocumentName(fileName);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile || !documentName.trim()) {
      toast.error('Please select a file and enter a document name');
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      // formData.append('name', documentName);

      const newDocument = await adsService.create(formData);
      
      setDocuments(prev => [newDocument, ...(prev || [])]);
      toast.success('Document uploaded successfully');
      setShowUploadModal(false);
      setSelectedFile(null);
      setDocumentName('');
      fetchDocuments();
    } catch (error) {
      console.error('Error uploading document:', error);
      toast.error('Failed to upload document');
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteClick = (document: Ads) => {
    setDocumentToDelete(document);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!documentToDelete) return;
    
    try {
      await adsService.delete(documentToDelete.id);
      setDocuments(prev => prev ? prev.filter(doc => doc.id !== documentToDelete.id) : []);
      toast.success('Ads deleted successfully');
      setShowDeleteModal(false);
      setDocumentToDelete(null);
    } catch (error) {
      console.error('Error deleting ads:', error);
      toast.error('Failed to delete ads');
    }
  };

  // const handleDownload = async (doc: Document) => {
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/documents/${doc.id}/download`, {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`
  //       }
  //     });
      
  //     if (!response.ok) {
  //       throw new Error('Download failed');
  //     }
      
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = doc.original_name;
  //     document.body.appendChild(a);
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //     document.body.removeChild(a);
  //   } catch (error) {
  //     console.error('Error downloading document:', error);
  //     toast.error('Failed to download document');
  //   }
  // };

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const formatDate = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString('en-CA', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

    const getFileIcon = (fileType: string, size = 24) => {
      if (fileType.includes('pdf')) {
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="#dc2626" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2v6h6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <text x="12" y="16" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">PDF</text>
          </svg>
        );
      }
      
      if (fileType.includes('word') || fileType.includes('document')) {
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="#2563eb" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2v6h6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <text x="12" y="16" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">DOC</text>
          </svg>
        );
      }
      
      if (fileType.includes('excel') || fileType.includes('spreadsheet')) {
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="#16a34a" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2v6h6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <text x="12" y="16" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold">XLS</text>
          </svg>
        );
      }
      
      if (fileType.includes('image')) {
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="#7c3aed" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2v6h6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="10" cy="12" r="1" fill="white"/>
            <path d="M21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      }
      
      // Default file icon
      return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="#6b7280" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14 2v6h6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 13H8" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M16 17H8" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M10 9H8" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      );
    };

  // if (!canManageDocuments) {
  //   return (
  //     <div className={styles.errorContainer}>
  //       <h2>Access Denied</h2>
  //       <p>You don't have permission to access documents.</p>
  //     </div>
  //   );
  // }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <h2>Ads</h2>
          <p>Manage and organize your ads</p>
        </div>
        <div className={styles.headerRight}>
          {/* Upload button - only for admin */}
          {(auth.user?.role === 'admin' || auth.user?.role === 'super_admin') && (
            <Button variant="primary" onClick={() => setShowUploadModal(true)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7,10 12,15 17,10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              Upload Ads
            </Button>
          )}
        </div>
      </div>

      {/* <div className={styles.searchSection}>
        <InputField
          name="search"
          type="text"
          placeholder="Search documents..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />
      </div> */}

      <div className={styles.documentsList}>
        {/* Debug info */}
        {loading ? (
          <div className={styles.loading}>
            <p>Loading ads...</p>
          </div>
        ) : !documents || documents.length === 0 ? (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>📁</div>
            <h3>No ads found</h3>
            <p>{searchTerm ? 'No ads match your search' : 'Upload your first ads to get started'}</p>
            {/* Upload button in empty state - only for admin */}
            {!searchTerm && auth.user?.role === 'admin' && (
              <Button variant="primary" onClick={() => setShowUploadModal(true)}>
                Upload Ads
              </Button>
            )}
          </div>
        ) : (
          <div className={styles.documentsTable}>
            <table>
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Name</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {documents.map((doc) => {
                  // Additional safety check for rendering
                  if (!doc || !doc.id) {
                    return null; // Skip invalid documents
                  }
                  
                  return (
                    <tr key={doc.id}>
                      <td className={styles.fileTypeCell}>
                        <span className={styles.fileIcon}>{getFileIcon("image")}</span>
                      </td>
                      <td className={styles.nameCell}>
                        <strong>{doc.image_url ? doc.image_url.split('/').pop() : ''}</strong>
                      </td>
                    
                      <td className={styles.dateCell}>
                        {formatDateDMY(doc.created_at)}
                      </td>
                      <td className={styles.actionsCell}>
                        <div className={styles.tableActions}>
                          {/* View button - always visible */}
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={() => window.open(`${BACKEND_BASE_URL}/documents/${doc.image_url}`, '_blank')}
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                              <circle cx="12" cy="12" r="3"></circle>
                            </svg>
                          </Button>
                          
                          {/* Delete button - only for admin */}
                          {(auth.user?.role === 'admin' || auth.user?.role === "super_admin") && (
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => handleDeleteClick(doc)}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="3,6 5,6 21,6"></polyline>
                                <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                              </svg>
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Upload Modal - only for admin */}
      {(auth.user?.role === 'admin' || auth.user?.role === 'super_admin' )&& (
        <Modal
          isOpen={showUploadModal}
          onClose={() => {
            setShowUploadModal(false);
            setSelectedFile(null);
            setDocumentName('');
          }}
          title="Upload Ads"
        >
          <div className={styles.uploadForm}>
            <div className={styles.fileUpload}>
              <label htmlFor="file-input" className={styles.fileInputLabel}>
                {selectedFile ? (
                  <div className={styles.fileSelected}>
                    <span className={styles.fileIcon}>📄</span>
                    <span className={styles.fileName}>{selectedFile.name}</span>
                    <span className={styles.fileSize}>{formatFileSize(selectedFile.size)}</span>
                  </div>
                ) : (
                  <div className={styles.fileDropZone}>
                    <svg width="48" height="48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="7 10 12 15 17 10"/>
                      <line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                    <p>Click to select a file or drag and drop</p>
                    <p className={styles.fileTypes}>Supports: JPEG, JPG, PNG</p>
                  </div>
                )}
              </label>
              <input
                id="file-input"
                type="file"
                onChange={handleFileSelect}
                accept=".jpg,.jpeg,.png,.gif"
                style={{ display: 'none' }}
              />
            </div>

            <InputField
              name="documentName"
              label="Ads File Name"
              type="text"
              value={documentName}
              onChange={(e) => setDocumentName(e.target.value)}
              placeholder="Enter a descriptive name for this ads"
              required
            />
          </div>

          <div className={styles.modalActions}>
            <Button
              variant="primary"
              onClick={handleUpload}
              disabled={!selectedFile || !documentName.trim() || uploading}
            >
              {uploading ? 'Uploading...' : 'Upload Ads'}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setShowUploadModal(false);
                setSelectedFile(null);
                setDocumentName('');
              }}
            >
              Cancel
            </Button>
          </div>
        </Modal>
      )}

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setDocumentToDelete(null);
        }}
        title="Delete Ads"
      >
        <div className={styles.deleteConfirmation}>
          <div className={styles.warningIcon}>⚠️</div>
          <h3>Are you sure you want to delete this ads?</h3>
          {documentToDelete && (
            <div className={styles.documentInfo}>
              <p><strong>Name:</strong> {documentToDelete.image_url ? documentToDelete.image_url.split('/').pop() : ''}</p>
            </div>
          )}
          <p className={styles.warningText}>
            This action cannot be undone. The ads will be permanently deleted from the server.
          </p>
        </div>

        <div className={styles.modalActions}>
          <Button
            variant="danger"
            onClick={handleDeleteConfirm}
          >
            Delete Ads
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setShowDeleteModal(false);
              setDocumentToDelete(null);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default AdsPage; 
